import { TitleBar } from "../TitleBar";
import { Link } from "react-router-dom";
import { Button } from "../Button";
import { ListItem } from "./ListItem";
import _ from "lodash";
import { useEffect, useState } from "react";
import apiAgent from "../../api/apiAgent";
import { checkTitle, mergeClass, useCheckSortable } from "../../utils";
import { IItemListProps } from "../interfaces";
import DraggableList from "./DraggableList";

// Standard Item List
export const ItemList = ({
  sortable,
  isCard = true,
  ...restProps
}: IItemListProps): JSX.Element => {
  const { data, modelName, customNoItemMessage } = restProps;
  const isSortable = useCheckSortable(modelName);

  if (data.length < 1)
    return <div className="opacity-50">{customNoItemMessage || "None"}</div>;

  return (
    <div
      className={mergeClass({
        "flex flex-wrap gap-5": isCard,
        "space-y-2": !isCard,
      })}
    >
      {isSortable ? (
        <DraggableList {...restProps} isCard={isCard} />
      ) : (
        data.map((item, index) => {
          return <ListItem key={index} item={item} {...restProps} />;
        })
      )}
    </div>
  );
};

// Related Item List
export const RelatedItemList = ({
  fromId,
  fromModel,
  model,
  title,
}: {
  fromId: number;
  fromModel: string;
  model: string;
  title: string;
}): JSX.Element => {
  const [data, setData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [refresh, setRefresh] = useState<boolean>(true);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await apiAgent.DataType.getAll(model);
      const allItems = response?.data || [];
      const relatedItems = allItems.reduce((arr: any[], item: any) => {
        if (item[`owner_${fromModel}_id`] === fromId) {
          return [...arr, item];
        } else return arr;
      }, []);
      setData(relatedItems);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [refresh]);

  return (
    <div className="pt-10">
      <TitleBar title={checkTitle(title)} isNotMain>
        {!isLoading && (
          <Link to={`/m/${model}/create?from=${fromModel}&id=${fromId}`}>
            <Button>+ Add</Button>
          </Link>
        )}
      </TitleBar>
      <ItemList
        data={data}
        modelName={model}
        returnModel={fromModel}
        returnId={fromId}
        refreshList={() => setRefresh(!refresh)}
      />
    </div>
  );
};

// Group of related Item lists
export const RelatedItemLists = ({
  relationships,
  model,
  id,
}: {
  relationships: any[];
  model: string;
  id: number;
}): JSX.Element => {
  return (
    <>
      {relationships.map((r, i) => {
        if ((r.type === "1-M" && r.is_owner) || r.type === "M-M") {
          return (
            <RelatedItemList
              key={i}
              model={r.related_to}
              fromModel={model}
              fromId={id}
              title={r.related_to}
            />
          );
        }
        return null;
      })}
    </>
  );
};
